

const ArrowUp = ({ color }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-up" stroke={color ? color : '#000'}><path d="m5 12 7-7 7 7" /><path d="M12 19V5" /></svg>
    )
}

export default ArrowUp;